import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { solutionsOp } from 'store/ducks/Solutions';
import { complianceEstOp } from 'store/ducks/ComplienceEst';
import { ITextAreaBoxProps } from 'store/ducks/Solutions/types';
import CustomTextarea from '../CustomTextarea';
import RichTextEditor from '../RichTextEditor';
import Helpers from 'utils/Helpers';
import useDeleteWithDependencyCheck from 'utils/hooks/useDeleteWithDependencyCheck';
import ApiService from 'utils/ApiCalls';
import * as Styled from './TextAreaBoxSolutions.styled';

interface IPopoverState {
  [id: number | string]: boolean;
}

const { useToken } = theme;

export const TextAreaBoxSolutions: React.FC<ITextAreaBoxProps> = ({
  solutions,
  solId,
  onDelete
}) => {
  const { token } = useToken();
  const dispatch = useDispatch();

  const { commentsData, lang, scheme, orgContext } = useSelector(
    (state: RootState) => ({
      commentsData: state.complianceEst.commentsData,
      lang: state.global.lang,
      scheme: state.global.scheme,
      orgContext: state.global.hierarchicalLevelsScope
    })
  );

  const filterParams = Helpers.toApiFilters(orgContext);

  const [popoverState, setPopoverState] = useState<IPopoverState>({});

  const { handleDelete: handleSolutionDelete } = useDeleteWithDependencyCheck({
    tableName: 'solutions',
    softDeleteFn: (id) => ApiService.softDeleteRecord('solutions', id),
    onSuccess: () => {
      const hasFilters = Object.keys(filterParams).length > 0;
      if (!orgContext || !hasFilters) return;
      solutionsOp.fetchSolutions(lang, filterParams).then((data) => {
        dispatch(solutionsOp.setSolutions(data));
      });
    },
    entityLabel: 'solution',
    lang
  });

  const handleDeleteClick = () => {
    const solutionId = solutions.sol_id;
    const isTemporary = String(solutionId).startsWith('new-');
    isTemporary
      ? onDelete?.(solutionId)
      : handleSolutionDelete(Number(solutionId));
  };

  const handleSolutionChange = (value: string) => {
    dispatch(
      solutionsOp.editSolutionValue(solId, solutions, 'sol_desc', value)
    );
    dispatch(complianceEstOp.setSaveDisabled(false));
  };

  const hide = (id: number | string) => {
    if (!id) return;

    setPopoverState((prevState) => ({
      ...prevState,
      [id]: false
    }));
  };

  // const drawComments = () => {
  //   const filteredComments = commentsData?.length
  //     ? commentsData.filter(
  //         (commentsDataItem: CommentItem) =>
  //           commentsDataItem.res_table_pk_ref === solutions.sol_id
  //       )
  //     : [];

  //   return (
  //     <>
  //       <CommentSection
  //         reqId={solutions.sol_id}
  //         data={filteredComments}
  //         tableRef={CommentTable.SOLUTIONS}
  //       />
  //       <a onClick={() => hide(Number(solutions.sol_id))}>Close</a>
  //     </>
  //   );
  // };

  const handleOpenChange = (id: number | string) => {
    if (!id) return;

    setPopoverState((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  return (
    <Styled.TextAreaElementsContainer>
      <Styled.TextAreaElementsContainer>
        <RichTextEditor
          value={solutions.sol_desc}
          onChange={(value) => handleSolutionChange(value)}
          onSave={(value) => handleSolutionChange(value)}
          placeholder='Type Solution'
          scheme={scheme}
        />
        <Styled.StyledButtonSection token={token}>
          {/* Comment section hidden
          <Popover
            placement='leftBottom'
            trigger='click'
            content={drawComments}
            title='Comments'
            open={!!(solId && popoverState[solId])}
            onOpenChange={() => handleOpenChange(solId)}
          >
            <CustomIconButton
              type='primary'
              shape='circle'
              icon={<CommentOutlined />}
              size='small'
              cursor='pointer'
            />
          </Popover>
          */}
          <Styled.StyledCustomIconButton
            token={token}
            scheme={scheme}
            type='primary'
            shape='circle'
            icon={<DeleteOutlined />}
            cursor='pointer'
            size='small'
            onClick={handleDeleteClick}
          />
        </Styled.StyledButtonSection>
      </Styled.TextAreaElementsContainer>
    </Styled.TextAreaElementsContainer>
  );
};
